var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoalWidgetIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 22,
    viewBox: "0 0 63 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_4673)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_4673)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 1.31944,
    y: 1.31034,
    width: 60,
    height: 20.0447,
    rx: 3.7931,
    stroke: "#7B7987",
    strokeWidth: 0.689655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.21604,
    y: 7.53065,
    width: 46.2069,
    height: 4.83949,
    rx: 2.41379,
    stroke: "#7B7987",
    strokeWidth: 0.689655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.87122,
    y: 7.18582,
    width: 26.2069,
    height: 5.52915,
    rx: 2.75862,
    fill: "#7B7987"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_4673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 22,
    fill: "white",
    transform: "translate(0.319458)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_4673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 21,
    fill: "white",
    transform: "translate(0.974609 0.965515)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalWidgetIcon);
export default __webpack_public_path__ + "static/media/goal-widget-icon.b7cbaf02874d9a9b7c81ac05bf42af12.svg";
export { ForwardRef as ReactComponent };